
<template>
  <div class="content">
    <!-- search bar -->
    <div class="row my-3 justify-content-end">
      <div class="col-8"></div>
       <div class="col-auto">
        <!-- Header Search Input -->
        <a-input-search class="header-search" :class="searchLoading ? 'loading' : ''" placeholder="Search by BusinessUnit#, Location#, Operator#, City, State, FirstName, LastName…"
          @search="onSearch" :loading='searchLoading' v-model="searchQuery">
          <svg slot="prefix" width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z"
              fill="#111827" />
          </svg>
        </a-input-search>
        <!-- / Header Search Input -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <div class="row justify-content-between align-items-between mx-3">

              <h5 class="card-title">User Roles</h5>
              
              <div>
                  <base-button class="btn btn-primary" @click="modalUserRoles = true">Add</base-button>
              </div>
              
              <modal :show.sync="modalUserRoles">
                <template slot="header">
                  <h5 class="modal-title" id="exampleModalLabel">Add UserRole</h5>
                </template>
                <div>
                  <form @submit.prevent>
  <base-input label="UserRoleId" type="text" placeholder="Enter UserRoleId" v-model="userRoleToAdd.userRoleId"></base-input>
  <base-input label="UserId" type="text" placeholder="Enter UserId" v-model="userRoleToAdd.userId"></base-input>
  <base-input label="RoleId" type="text" placeholder="Enter RoleId" v-model="userRoleToAdd.roleId"></base-input>
                  </form>
                </div>
                <template slot="footer">
                  <base-button type="primary" @click="handleAddSubmitted()">Save</base-button>
                </template>
              </modal>
            </div>
          </template>


          <!-- Conditionally render the view based on the 'isTableView' flag -->
          <div v-if="isTableView">
            <!-- Render the existing Table View -->
            <a-table :columns="columns" :data-source="userRoles" :row-key="record => record.UserRoleId" :pagination="pagination"
              :loading="searchLoading" @change="onTableChange" :scroll="{ x: 'max-content' }">

              <template slot="userRoleId" slot-scope="dataIndex">
              	<router-link  :to="`/userRole/${dataIndex}`"><a >{{ dataIndex }}</a></router-link>
              </template>
		              <template slot="userId" slot-scope="dataIndex">
	              	<router-link  :to="`/user/${dataIndex.user}`"><a >{{ dataIndex.userId }}</a></router-link>
	              </template>
			              <template slot="roleId" slot-scope="dataIndex">
	              	<router-link  :to="`/role/${dataIndex.role}`"><a >{{ dataIndex.roleId }}</a></router-link>
	              </template>
	

             <template slot="lastModified" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="createdOn" slot-scope="dataIndex">
              	{{ formatTime(dataIndex) }}
              </template>
              <template slot="blackOutStartDate" slot-scope="dataIndex">
              	{{ formatDate(dataIndex) }}
              </template>
            </a-table>
          </div>
          <div v-else>
            <!-- Render the Picture View  -->
            <UserRolePictureView :userRoles="userRoles" />
          </div>

        </card>
      </div>
    </div>

  </div>
</template>

<script>
import Modal from "@/components/Modal";
import BaseButton from "@/components/BaseButton";
import BaseInput from "@/components/BaseInput";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import { Card } from "@/components/Card";
import UserRoleService from "../services/UserRoleService";
import { ASelect, ASelectOption, AButton, Table, Pagination } from "ant-design-vue";
import UserRolePictureView from './UserRolePictureView.vue';


const userRolesColumns = [
  "userRoleId",
  "year",
  "date",
  "competitionId",
  "userRoleId"
]

export default {
  props: {
    userRoles: {
      type: Array,
      required: true,
    },
    totalElements: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
  },
  components: {
    Card,
    Modal,
    BaseButton,
    BaseInput,
    Table,

    Pagination,
    UserRolePictureView
  },

  data() {
    return {
      modalUserRoles: false,
        isTableView: true,

      columns: [
        {
          title: 'User Role Id',
				dataIndex: 'userRoleId',
	          visible: true,
          scopedSlots: { customRender: 'userRoleId' },
          sorter: true
          //sorter: (a, b) => a.userRoleId - b.userRoleId,
          //sorter: (a, b) => a.userRoleId.localeCompare(b.userRoleId),
        },
        {
          title: 'User Id',
							dataIndex: 'user',
			          visible: true,
          scopedSlots: { customRender: 'userId' },
          sorter: true
          //sorter: (a, b) => a.userId - b.userId,
          //sorter: (a, b) => a.userId.localeCompare(b.userId),
        },
        {
          title: 'Role Id',
							dataIndex: 'role',
			          visible: true,
          scopedSlots: { customRender: 'roleId' },
          sorter: true
          //sorter: (a, b) => a.roleId - b.roleId,
          //sorter: (a, b) => a.roleId.localeCompare(b.roleId),
        },
      ],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total) => `Total ${total} userRoles`,
      },

      userRoles: [],
      userRoleToAdd: {},

      userRolesTable: {
        columns: [...userRolesColumns],
        data: [],
      },

      // New properties for sorting and searching
      sortBy: 'userRoleId',           // Column to sort by
      sortOrder: 'asc',     // Sort order (asc or desc)
      searchQuery: '',      // Search query
      searchLoading: false, // Initialize searchLoading property


    };
  },
  watch: {
    searchQuery: {
      handler: "handleSearchQueryChanged", // Call the fetchData method when searchQuery changes
      immediate: true, // Trigger immediately when the component is mounted
    },
  },

  methods: {

    async renderUserRolesTable() {
      this.searchLoading = true; // Set searchLoading to true while fetching data
      this.searchLoading = false;

      this.pagination.total = this.totalElements;
      this.pagination.current = this.page;

      let userRolesTableData = [];
      for (let i = 0; i < this.userRoles.length; i++) {
        userRolesTableData.push({
          id: i,
          userRoleId: this.userRoles[i].userRoleId,
          year: this.userRoles[i].year,
          date: this.userRoles[i].date,
          competitionId: this.userRoles[i].competitionId,
          userRoleId: this.userRoles[i].userRoleId,
        });

      }
      this.searchLoading = false;
    },

    async onTableChange(pagination, filters, sorter) {
      if (sorter && sorter.field && sorter.order) {
        this.sortBy = sorter.field;
        if (sorter.order == "ascend") {
            this.sortOrder = "asc";
        } else {
            this.sortOrder = "desc";
        }
      }
      if (pagination) {
        this.pagination.current = pagination.current;
        this.pagination.pageSize = pagination.pageSize;
      }

	  this.$emit('get-all-user-roles',this.sortBy,this.sortOrder,this.pagination.current-1,this.pagination.pageSize);
      this.handleTableChanged()
    },
	
	initializeColumns() {
        this.columns = this.columns.filter(item => item.visible);
    },

    routingToApplicationDetail(id) {
      this.$router.push({ name: 'ApplicationDetail', params: { applicationId: id.toString() }})
    },
    routingToDomainClassDetail(id) {
      this.$router.push({ name: 'DomainClassDetail', params: { domainClassId: id.toString() }})
    },
    routingToFieldDetail(id) {
      this.$router.push({ name: 'FieldDetail', params: { fieldId: id.toString() }})
    },
    routingToDetailViewTableDetail(id) {
      this.$router.push({ name: 'DetailViewTableDetail', params: { detailViewTableId: id.toString() }})
    },
    routingToMappedClassDetail(id) {
      this.$router.push({ name: 'MappedClassDetail', params: { mappedClassId: id.toString() }})
    },
    routingToNameDetail(id) {
      this.$router.push({ name: 'NameDetail', params: { nameId: id.toString() }})
    },
    routingToSubmenuDetail(id) {
      this.$router.push({ name: 'SubmenuDetail', params: { submenuId: id.toString() }})
    },
    routingToFieldTypeDetail(id) {
      this.$router.push({ name: 'FieldTypeDetail', params: { fieldTypeId: id.toString() }})
    },
    routingToUserDetail(id) {
      this.$router.push({ name: 'UserDetail', params: { userId: id.toString() }})
    },
    routingToRoleDetail(id) {
      this.$router.push({ name: 'RoleDetail', params: { roleId: id.toString() }})
    },
    routingToUserRoleDetail(id) {
      this.$router.push({ name: 'UserRoleDetail', params: { userRoleId: id.toString() }})
    },
    
    handleSearchQueryChanged() {
    	console.log("handleSearchQueryChanged CALLED FROM @search")
    	this.$root.$emit('searchQueryForUserRolesChanged', this.searchQuery);
		//this.renderUserRolesTable();
    },

    onSearch(value) {
      console.log(value);
      this.searchQuery = value; // Update searchQuery when the user types
    },

    toggleView() {
      this.isTableView = !this.isTableView;
    },
	
	async handleAddSubmitted() {
      this.modalUserRoles = false;

      const currentDate = new Date().getTime();
      this.userRoleToAdd.created = currentDate;

      const jsonData = JSON.stringify(this.userRoleToAdd);
      console.log(jsonData);
      
      const res = await UserRoleService.addUserRole(jsonData);

      if (res.status === 200) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          type: "success",
          timeout: 3000,
        });
      }
	},
	
	handleTableChanged() {
	},
	
	formatTime(dateString) {
      if(dateString !== null){
        const date = new Date(dateString);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')} EST`;
      }
      // Format the date here as needed, for example:
    },  
    
 formatDate(dateString) {
    if (dateString !== null) {
	    const date = new Date(dateString);
	    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	    const day = String(date.getDate()).padStart(2, '0');
	    const monthAbbreviation = months[date.getMonth()];
	    const year = date.getFullYear();
	    return `${day} ${monthAbbreviation} ${year}`;
  	}
  	// Handle the case when dateString is null or invalid
  	return '';
    
   },

  },
  mounted() {
  	this.initializeColumns();
    this.renderUserRolesTable();
  }
};
</script>

<style>
.modal-dialog {
  margin-top: -300px;
}
.ant-table-row  {
	text-align: center;
}
.ant-table-thead th span {
	text-align: center;
	width: 100%
}
.ant-table-fixed td span {
    text-align: center;
}
.header-search {
  width: 300px !important;
  margin-left: auto !important;
}
</style>
